import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appScrollItem]',
  standalone: true
})
export class ScrollItemDirective {
  constructor(private elRef: ElementRef) { }

  setActive(): void {
    window.scrollTo({ left: 0, top: this.elRef.nativeElement.offsetTop, behavior: 'instant' });
  }
}
